import { ThemeProvider } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { theme } from "../../constants/muiTheme";
import HeaderPurchase from "./HeaderPurchase";
import { useLocation, useNavigate } from "react-router-dom";
import KonsultasiDokter from "../../assets/category-icons/icon-chat-doctor.png";
import { GlobalStateContext } from "../context/GlobalStateContext";
import { useCustomerChatUnread } from "../../hooks/useCustomerChatUnread";
import Footer from "./Footer";

const PageTemplate = ({
  mainComponent,
  noPadding,
  header,
  noFooter = false,
  logo = "Logo",
  back,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { topicId, customerChatUnreadCount, setCustomerChatUnreadCount } =
    useContext(GlobalStateContext);

  const isOnChatPage = location.pathname.startsWith(
    "/consultation/chat-with-doctor",
  );
  useCustomerChatUnread(topicId, isOnChatPage, setCustomerChatUnreadCount);

  const showChatBubble = Boolean(topicId) && !isOnChatPage;

  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobileView(window.innerWidth < 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const shouldShowSearch = () => {
    return (
      location.pathname === "/" ||
      location.pathname.includes("/purchase/outlet/")
    );
  };

  const notShowCartIcon = () => {
    return (
      location.pathname === "/purchase/checkout" ||
      location.pathname === "/purchase/checkout/payment-method"
    );
  };

  const notShowSearchIcon = () => {
    return (
      location.pathname === "/purchase/transaction-list" ||
      location.pathname === "/purchase/cart-details" ||
      location.pathname === "/profile" ||
      location.pathname === "/location-address" ||
      location.pathname === "/location-address/my-address" ||
      location.pathname === "/location-address/my-address/new" ||
      location.pathname === "/purchase/category-list" ||
      location.pathname === "/purchase/checkout" ||
      location.pathname === "/purchase/checkout/payment-method" ||
      location.pathname === "/profile/change" ||
      location.pathname === "/consultation/history" ||
      location.pathname.startsWith("/location-address/my-address/edit/") ||
      location.pathname.startsWith("/purchase/detail-transaction/")
    );
  };

  const shouldHideFooterOnMobileTransactionPages =
    isMobileView &&
    (location.pathname === "/purchase/transaction-list" ||
      location.pathname === "/purchase/cart-details" ||
      location.pathname === "/profile" ||
      location.pathname === "/location-address" ||
      location.pathname === "/location-address/my-address" ||
      location.pathname === "/location-address/my-address/new" ||
      location.pathname === "/purchase/category-list" ||
      location.pathname === "/purchase/checkout" ||
      location.pathname === "/purchase/checkout/payment-method" ||
      location.pathname === "/profile/change" ||
      location.pathname === "/consultation/history" ||
      location.pathname.startsWith("/location-address/my-address/edit/") ||
      location.pathname.startsWith("/purchase/detail-transaction/"));

  return (
    <ThemeProvider theme={theme}>
      <div
        className={`${
          isMobileView ? "pb-16" : ""
        } bg-white md:bg-gradient-to-b md:from-secondary md:via-white md:to-[#c6f8ff] text-[12px] min-h-screen flex flex-col`}
      >
        <HeaderPurchase
          isSearch={shouldShowSearch()}
          isNotSearchIcon={notShowSearchIcon()}
          isNotCartIcon={notShowCartIcon()}
          logo={logo}
          back={back}
        />
        <div
          className={`${
            isMobileView && shouldShowSearch()
              ? "pt-[120px]"
              : isMobileView && !shouldShowSearch()
                ? "pt-[64px]"
                : "pt-0"
          } text-[#454257] md:min-h-[calc(100vh-80px)]`}
        >
          <div className={`relative ${noPadding ? "" : "px-[12px]"}`}>
            <div className="md:max-w-7xl md:mx-auto xl:px-0 md:px-8 md:mb-4">
              {header ? (
                <p className="text-[24px] md:text-[28px] font-bold mb-3 md:mb-4 text-slate-800">
                  {header}
                </p>
              ) : null}
              {showChatBubble && (
                <button
                  type="button"
                  onClick={() =>
                    navigate(`/consultation/chat-with-doctor/${topicId}`, {
                      state: { type: 2 },
                    })
                  }
                  className="block lg:hidden fixed bottom-20 right-4 z-[99999] bg-slate-100 rounded-full p-1 shadow hover:bg-slate-200 active:scale-95 transition-all"
                  aria-label="Buka chat dengan dokter"
                >
                  <div className="relative w-12 h-12">
                    <img
                      src={KonsultasiDokter}
                      alt="Konsultasi Dokter"
                      className="w-full h-full object-contain"
                    />
                    {customerChatUnreadCount > 0 && (
                      <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] flex items-center justify-center rounded-full bg-red-500 text-white text-[10px] font-bold px-1">
                        {customerChatUnreadCount > 99
                          ? "99+"
                          : customerChatUnreadCount}
                      </span>
                    )}
                  </div>
                </button>
              )}

              {mainComponent}
            </div>
          </div>
        </div>

        {!noFooter && !shouldHideFooterOnMobileTransactionPages && <Footer />}
      </div>
    </ThemeProvider>
  );
};

export default PageTemplate;
